var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{attrs:{"id":"titulo"}},[_vm._v(" "+_vm._s(_vm.contents)),_c('SvgIcon',{staticClass:"wave",attrs:{"data":require("@svgs/wave.svg"),"original":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }